module.exports = __webpack_public_path__ + "03_medium_gold.3250061e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_medium_gold.png
// module id = xRp3
// module chunks = 0